import { useTheme } from "@emotion/react";
import { Container, Grid2 } from "@mui/material";
import React, { useContext } from "react";
import { RecipeContext } from "../../contexts/RecipeContext";
import useSortedRecipes from "../../hooks/RecipeHooks/useSortedRecipes";
import { recipeGridItem, recipeListContainer } from "../../styles/recipeStyles";
import ErrorMessage from "../Common/ErrorMessage";
import LoadingSpinner from "../Common/LoadingSpinner";
import RecipeCard from "./RecipeCard";

const RecipeList = () => {
  const theme = useTheme();
  const { loading, error } = useContext(RecipeContext);

  const sortedRecipes = useSortedRecipes();

  if (loading) return <LoadingSpinner />;
  if (error) return <ErrorMessage error={error} />;

  return (
    <Container sx={recipeListContainer(theme)}>
      <Grid2 container spacing={2} justifyContent="center">
        {sortedRecipes.map((recipe) => (
          <Grid2
            key={recipe.id}
            grid={{
              xs: 12,
              sm: 8,
              md: 6,
              lg: 4,
            }}
            sx={recipeGridItem(theme)}
          >
            <RecipeCard recipe={recipe} />
          </Grid2>
        ))}
      </Grid2>
    </Container>
  );
};

export default RecipeList;
